// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1FrDL","footer":"ModalInfo_footer__VnteH"};